// Model.js
// -----------------------
// @module Case
define("MHI.ItemPriceHistory.ItemPriceHistory.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/ItemPriceHistory/SuiteScript2/ItemPriceHistory.Service.ss"
            ),
            true
        )
});
});
